module.exports = __webpack_public_path__ + "static/media/buscojobs.ef832c24.svg";